import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api/client';

export function MfaSetup() {
  const navigate = useNavigate();
  const [qrCode, setQrCode] = useState('');
  const [secret, setSecret] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.post('/auth/mfa/setup').then(({ data }) => {
      setQrCode(data.qrCode);
      setSecret(data.secret);
    });
  }, []);

  async function handleVerify() {
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/mfa/verify', { code });
      navigate('/events');
    } catch {
      setError('Invalid code. Try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-[#F8F9FF] flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-8">
        <h2 className="text-2xl font-serif font-bold text-indigo-700 mb-2">Set Up Two-Factor Authentication</h2>
        <p className="text-stone-500 text-sm mb-6">
          Scan this QR code with your authenticator app (Google Authenticator, Authy, etc.)
        </p>

        {qrCode && (
          <div className="flex flex-col items-center mb-6">
            <img src={qrCode} alt="MFA QR Code" className="w-48 h-48 border border-stone-200 rounded-lg" />
            <p className="mt-3 text-xs text-stone-400 font-mono break-all text-center">{secret}</p>
          </div>
        )}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-1">Enter the 6-digit code to confirm</label>
            <input
              type="text" value={code} onChange={e => setCode(e.target.value)}
              maxLength={6} placeholder="000000"
              className="w-full border border-stone-300 rounded-lg px-3 py-2 text-center text-2xl tracking-widest focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
          {error && <p className="text-red-600 text-sm">{error}</p>}
          <button
            onClick={handleVerify} disabled={loading || code.length < 6}
            className="w-full bg-indigo-600 text-white rounded-lg py-2 text-sm font-medium hover:bg-indigo-700 disabled:opacity-50 transition-colors"
          >
            {loading ? 'Verifying…' : 'Enable MFA & Continue'}
          </button>
          <button
            onClick={() => navigate('/events')}
            className="w-full text-stone-500 text-sm hover:text-stone-700"
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}
